"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoundForce = exports.Newton = void 0;
var uom_1 = require("uom");
// import { Kilogram } from "./base-units";
var UnitTimes = require("../unit-times");
var acceleration_1 = require("./acceleration");
/**
 * The derived unit for force ( <code>N</code> ).
 * One newton is the force required to give a mass of 1 kilogram an Force of 1 metre per second per second.
 * It is named after the English mathematician and physicist Sir Isaac Newton (1642-1727).
 */
exports.Newton = UnitTimes.massByAcceleration("Newton", uom_1.BaseUnits.Kilogram, acceleration_1.MeterPerSquareSecond);
// Force
exports.PoundForce = uom_1.Unit.divideNumber("PoundForce", 8896443230521.0, uom_1.Unit.timesNumber("", 2000000000000.0, exports.Newton));
//# sourceMappingURL=force.js.map